<script setup>
import usePlatform from '../../Composables/usePlatform'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import WaitingText from '../UI/Text/WaitingText.vue'

defineProps({
  waiting: {
    type: Boolean,
    default: false,
  },
  eligible: {
    type: Boolean,
    default: false,
  },
  unknown: {
    type: Boolean,
    default: false,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
  company: {
    type: String,
    default: '',
  },
  sirenCode: {
    type: String,
    default: '',
  },
  userPlatforms: {
    type: Array,
    default: () => [],
  },
})

const { defaultPlatform } = usePlatform()
</script>

<template>
  <ModalDialog
    id="modalVerifySiren"
    title-t="home.dashboardQuotation.modal.title"
    class-body="text-center"
    e2e-modal="verifySiren"
  >
    <WaitingText v-if="waiting" class-spinner="text-center fs-18">
      <b>{{ $t('home.dashboardQuotation.modal.waiting') }}</b>
    </WaitingText>
    <template v-else>
      <template v-if="eligible">
        <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: flex">
          <div
            class="swal2-success-circular-line-left"
            style="background-color: rgb(255, 255, 255); background-position: initial; background-repeat: initial"
          ></div>
          <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
          <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
          <div class="swal2-success-ring"></div>
          <div
            class="swal2-success-fix"
            style="background-color: rgb(255, 255, 255); background-position: initial; background-repeat: initial"
          ></div>
          <div
            class="swal2-success-circular-line-right"
            style="background-color: rgb(255, 255, 255); background-position: initial; background-repeat: initial"
          ></div>
        </div>

        <p
          class="text-center fs-18 mb-1"
          e2e-data="eligibilityResult"
          v-html="$t('home.dashboardQuotation.modal.resultEligible', { societe: company })"
        ></p>

        <div v-if="userPlatforms.length == 1" class="btn-spacer d-flex justify-content-center flex-wrap">
          <p class="text-center">
            <a
              v-for="pp in defaultPlatform.platformParams"
              id="link_devis"
              :key="pp.id"
              :href="'devis/simulation.php?s=' + sirenCode + '&pp=' + pp.id + '&index=creer'"
              style="text-decoration: none"
              class="btn btn-lg btn-primary my-1"
              e2e-button="createSimulation"
            >
              {{ pp.label ? pp.label : pp.name ? pp.name : $t('quotation.home.defaultLabel') }}
            </a>
          </p>
        </div>
        <div v-if="userPlatforms.length > 1" class="btn-spacer d-flex justify-content-center">
          <p class="text-center">
            <a
              id="link_devis"
              :href="'devis/simulation.php?s=' + sirenCode + '&p=' + defaultPlatform?.id + '&index=creer'"
              style="text-decoration: none"
              class="btn btn-lg btn-primary"
              e2e-button="createSimulation"
            >
              {{ $t('home.dashboardQuotation.modal.create') }}
            </a>
          </p>
        </div>
      </template>
      <template v-if="unknown">
        <p
          class="text-center fs-18 mt-4 mb-1"
          v-html="$t('home.dashboardQuotation.modal.resultInconnu', { societe: company })"
          e2e-data="eligibilityResultUnknown"
        />
        <br />
        <p class="text-center fs-18" v-html="$t('home.dashboardQuotation.modal.resultContact')" />
      </template>
      <template v-if="hasError">
        <div class="swal2-icon swal2-error swal2-animate-error-icon" style="display: flex">
          <span class="swal2-x-mark"
            ><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span
          ></span>
        </div>
        <p class="text-center fs-18">{{ errorMessage }}</p>
      </template>
    </template>
  </ModalDialog>
</template>
